function copyToClipboard(generatedString: string) {
    const copyText = new Promise((resolve) => {
        if (navigator.clipboard != undefined) {
            // Modern browsers
            navigator.clipboard.writeText(generatedString).then(
                function () {
                    resolve(true);
                },
                function (err) {
                    console.error("Could not copy text: ", err);
                }
            );
        } else {
            try {
                // Internet Explorer
                const el = document.createElement("textarea");
                el.value = generatedString;
                document.body.appendChild(el);
                el.focus();
                el.select();
                document.execCommand("copy");
                document.body.removeChild(el);
                resolve(true);
            } catch {
                console.log("Unable to copy to clipboard");
            }
        }
    });
    return copyText;
}

export default copyToClipboard;
